// This file is auto-generated and contains a map with all design-tokens in @tdcerhverv/parrotfish
import Account_number from '@tdcerhverv/parrotfish/dist/icons/Icons/Account_number.svg';
import Align_left from '@tdcerhverv/parrotfish/dist/icons/Icons/Align_left.svg';
import Align_right from '@tdcerhverv/parrotfish/dist/icons/Icons/Align_right.svg';
import Announce_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Announce_light.svg';
import Antenna_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Antenna_light.svg';
import Antenna_signal from '@tdcerhverv/parrotfish/dist/icons/Icons/Antenna_signal.svg';
import Application_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Application_light.svg';
import Arrow_circle_down from '@tdcerhverv/parrotfish/dist/icons/Icons/Arrow_circle_down.svg';
import Arrow_circle_up from '@tdcerhverv/parrotfish/dist/icons/Icons/Arrow_circle_up.svg';
import Arrow_directions from '@tdcerhverv/parrotfish/dist/icons/Icons/Arrow_directions.svg';
import Arrow_down from '@tdcerhverv/parrotfish/dist/icons/Icons/Arrow_down.svg';
import Arrow_down_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Arrow_down_light.svg';
import Arrow_left from '@tdcerhverv/parrotfish/dist/icons/Icons/Arrow_left.svg';
import Arrow_left_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Arrow_left_light.svg';
import Arrow_right from '@tdcerhverv/parrotfish/dist/icons/Icons/Arrow_right.svg';
import Arrow_right_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Arrow_right_light.svg';
import Arrow_up from '@tdcerhverv/parrotfish/dist/icons/Icons/Arrow_up.svg';
import Arrow_up_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Arrow_up_light.svg';
import Arrows_up_down from '@tdcerhverv/parrotfish/dist/icons/Icons/Arrows_up_down.svg';
import Assistapp_filled from '@tdcerhverv/parrotfish/dist/icons/Icons/Assistapp_filled.svg';
import Assistapp_stroke_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Assistapp_stroke_light.svg';
import At_Sign from '@tdcerhverv/parrotfish/dist/icons/Icons/At_Sign.svg';
import Attach from '@tdcerhverv/parrotfish/dist/icons/Icons/Attach.svg';
import Attach_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Attach_light.svg';
import Autoattendant from '@tdcerhverv/parrotfish/dist/icons/Icons/Autoattendant.svg';
import Backspace from '@tdcerhverv/parrotfish/dist/icons/Icons/Backspace.svg';
import Bank from '@tdcerhverv/parrotfish/dist/icons/Icons/Bank.svg';
import Battery_full_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Battery_full_light.svg';
import Battery_low_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Battery_low_light.svg';
import Battery_power from '@tdcerhverv/parrotfish/dist/icons/Icons/Battery_power.svg';
import Book from '@tdcerhverv/parrotfish/dist/icons/Icons/Book.svg';
import Brain_Head_2_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Brain_Head_2_light.svg';
import Briefcase from '@tdcerhverv/parrotfish/dist/icons/Icons/Briefcase.svg';
import Broken_link from '@tdcerhverv/parrotfish/dist/icons/Icons/Broken_link.svg';
import Browser_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Browser_light.svg';
import Bus_station_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Bus_station_light.svg';
import Business from '@tdcerhverv/parrotfish/dist/icons/Icons/Business.svg';
import Cable_copper from '@tdcerhverv/parrotfish/dist/icons/Icons/Cable_copper.svg';
import Cable_copper_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Cable_copper_light.svg';
import Cable_fiber_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Cable_fiber_light.svg';
import Cable_lan_ethernet from '@tdcerhverv/parrotfish/dist/icons/Icons/Cable_lan_ethernet.svg';
import Cable_lan_ethernet_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Cable_lan_ethernet_light.svg';
import Calendar from '@tdcerhverv/parrotfish/dist/icons/Icons/Calendar.svg';
import Calendar_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Calendar_light.svg';
import Call_made from '@tdcerhverv/parrotfish/dist/icons/Icons/Call_made.svg';
import Call_missed from '@tdcerhverv/parrotfish/dist/icons/Icons/Call_missed.svg';
import Call_recieved from '@tdcerhverv/parrotfish/dist/icons/Icons/Call_recieved.svg';
import Callflow from '@tdcerhverv/parrotfish/dist/icons/Icons/Callflow.svg';
import Callflow_incomplete from '@tdcerhverv/parrotfish/dist/icons/Icons/Callflow_incomplete.svg';
import Callflow_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Callflow_light.svg';
import Callmanager from '@tdcerhverv/parrotfish/dist/icons/Icons/Callmanager.svg';
import Cart_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Cart_light.svg';
import Certificate_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Certificate_light.svg';
import Change from '@tdcerhverv/parrotfish/dist/icons/Icons/Change.svg';
import Chat from '@tdcerhverv/parrotfish/dist/icons/Icons/Chat.svg';
import Chat_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Chat_light.svg';
import Check from '@tdcerhverv/parrotfish/dist/icons/Icons/Check.svg';
import Check_1 from '@tdcerhverv/parrotfish/dist/icons/Icons/Check_1.svg';
import Check_Badge from '@tdcerhverv/parrotfish/dist/icons/Icons/Check_Badge.svg';
import Checkmark from '@tdcerhverv/parrotfish/dist/icons/Icons/Checkmark.svg';
import Checkmark_round_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Checkmark_round_light.svg';
import Checkmark_stroke_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Checkmark_stroke_light.svg';
import Clear from '@tdcerhverv/parrotfish/dist/icons/Icons/Clear.svg';
import Close from '@tdcerhverv/parrotfish/dist/icons/Icons/Close.svg';
import Close_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Close_light.svg';
import Cloud from '@tdcerhverv/parrotfish/dist/icons/Icons/Cloud.svg';
import Cloud_key from '@tdcerhverv/parrotfish/dist/icons/Icons/Cloud_key.svg';
import Cloud_key_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Cloud_key_light.svg';
import Cloud_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Cloud_light.svg';
import Cloud_wifi_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Cloud_wifi_light.svg';
import Collapse_left from '@tdcerhverv/parrotfish/dist/icons/Icons/Collapse_left.svg';
import Collapse_right from '@tdcerhverv/parrotfish/dist/icons/Icons/Collapse_right.svg';
import Columns from '@tdcerhverv/parrotfish/dist/icons/Icons/Columns.svg';
import Common_file_text_warning from '@tdcerhverv/parrotfish/dist/icons/Icons/Common_file_text_warning.svg';
import Company_heart_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Company_heart_light.svg';
import Company_settings from '@tdcerhverv/parrotfish/dist/icons/Icons/Company_settings.svg';
import Comprimised_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Comprimised_light.svg';
import Computer_to_cloud_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Computer_to_cloud_light.svg';
import Consumption from '@tdcerhverv/parrotfish/dist/icons/Icons/Consumption.svg';
import Consumtion_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Consumtion_light.svg';
import Contact_person from '@tdcerhverv/parrotfish/dist/icons/Icons/Contact_person.svg';
import Contacts from '@tdcerhverv/parrotfish/dist/icons/Icons/Contacts.svg';
import Covrage from '@tdcerhverv/parrotfish/dist/icons/Icons/Covrage.svg';
import Crypto_mining_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Crypto_mining_light.svg';
import Cursor_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Cursor_light.svg';
import Cyper_crime from '@tdcerhverv/parrotfish/dist/icons/Icons/Cyper_crime.svg';
import DKK_transparent_light from '@tdcerhverv/parrotfish/dist/icons/Icons/DKK_transparent_light.svg';
import DSL from '@tdcerhverv/parrotfish/dist/icons/Icons/DSL.svg';
import Danmarks_bedste_5g_mobilnet_lys_blaa from '@tdcerhverv/parrotfish/dist/icons/Icons/Danmarks_bedste_5g_mobilnet_lys_blaa.svg';
import Danmarks_bedste_5g_mobilnet_lys_blaa_inverted from '@tdcerhverv/parrotfish/dist/icons/Icons/Danmarks_bedste_5g_mobilnet_lys_blaa_inverted.svg';
import Danmarks_bedste_5g_mobilnet_moerk_blaa from '@tdcerhverv/parrotfish/dist/icons/Icons/Danmarks_bedste_5g_mobilnet_moerk_blaa.svg';
import Danmarks_bedste_5g_mobilnet_moerk_blaa_inverted from '@tdcerhverv/parrotfish/dist/icons/Icons/Danmarks_bedste_5g_mobilnet_moerk_blaa_inverted.svg';
import Danmarks_bedste_mobilnet_8_aar_lys_blaa from '@tdcerhverv/parrotfish/dist/icons/Icons/Danmarks_bedste_mobilnet_8_aar_lys_blaa.svg';
import Danmarks_bedste_mobilnet_8_aar_lys_blaa_inverted from '@tdcerhverv/parrotfish/dist/icons/Icons/Danmarks_bedste_mobilnet_8_aar_lys_blaa_inverted.svg';
import Danmarks_bedste_mobilnet_8_aar_moerk_blaa from '@tdcerhverv/parrotfish/dist/icons/Icons/Danmarks_bedste_mobilnet_8_aar_moerk_blaa.svg';
import Danmarks_bedste_mobilnet_8_aar_moerk_blaa_inverted from '@tdcerhverv/parrotfish/dist/icons/Icons/Danmarks_bedste_mobilnet_8_aar_moerk_blaa_inverted.svg';
import Danmarks_bedste_mobilnet_bedst_i_test_lys_blaa from '@tdcerhverv/parrotfish/dist/icons/Icons/Danmarks_bedste_mobilnet_bedst_i_test_lys_blaa.svg';
import Danmarks_bedste_mobilnet_bedst_i_test_lys_blaa_inverted from '@tdcerhverv/parrotfish/dist/icons/Icons/Danmarks_bedste_mobilnet_bedst_i_test_lys_blaa_inverted.svg';
import Danmarks_bedste_mobilnet_bedst_i_test_moerk_blaa from '@tdcerhverv/parrotfish/dist/icons/Icons/Danmarks_bedste_mobilnet_bedst_i_test_moerk_blaa.svg';
import Danmarks_bedste_mobilnet_bedst_i_test_moerk_blaa_inverted from '@tdcerhverv/parrotfish/dist/icons/Icons/Danmarks_bedste_mobilnet_bedst_i_test_moerk_blaa_inverted.svg';
import Danmarks_bedste_mobilnet_lys_blaa from '@tdcerhverv/parrotfish/dist/icons/Icons/Danmarks_bedste_mobilnet_lys_blaa.svg';
import Danmarks_bedste_mobilnet_lys_blaa_inverted from '@tdcerhverv/parrotfish/dist/icons/Icons/Danmarks_bedste_mobilnet_lys_blaa_inverted.svg';
import Danmarks_bedste_mobilnet_moerk_blaa from '@tdcerhverv/parrotfish/dist/icons/Icons/Danmarks_bedste_mobilnet_moerk_blaa.svg';
import Danmarks_bedste_mobilnet_moerk_blaa_inverted from '@tdcerhverv/parrotfish/dist/icons/Icons/Danmarks_bedste_mobilnet_moerk_blaa_inverted.svg';
import Danmarks_bedste_mobilnet_symbol_og_txt_lys_blaa from '@tdcerhverv/parrotfish/dist/icons/Icons/Danmarks_bedste_mobilnet_symbol_og_txt_lys_blaa.svg';
import Danmarks_bedste_mobilnet_symbol_og_txt_lys_blaa_inverted from '@tdcerhverv/parrotfish/dist/icons/Icons/Danmarks_bedste_mobilnet_symbol_og_txt_lys_blaa_inverted.svg';
import Danmarks_bedste_mobilnet_symbol_og_txt_moerk_blaa from '@tdcerhverv/parrotfish/dist/icons/Icons/Danmarks_bedste_mobilnet_symbol_og_txt_moerk_blaa.svg';
import Danmarks_bedste_mobilnet_symbol_og_txt_moerk_blaa_inverted from '@tdcerhverv/parrotfish/dist/icons/Icons/Danmarks_bedste_mobilnet_symbol_og_txt_moerk_blaa_inverted.svg';
import Dashboard from '@tdcerhverv/parrotfish/dist/icons/Icons/Dashboard.svg';
import Database_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Database_light.svg';
import Delivery_truck_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Delivery_truck_light.svg';
import Denmark_map_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Denmark_map_light.svg';
import Desk_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Desk_light.svg';
import Dial_number_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Dial_number_light.svg';
import Dialog_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Dialog_light.svg';
import Diamond from '@tdcerhverv/parrotfish/dist/icons/Icons/Diamond.svg';
import Document from '@tdcerhverv/parrotfish/dist/icons/Icons/Document.svg';
import Document_time from '@tdcerhverv/parrotfish/dist/icons/Icons/Document_time.svg';
import Documents from '@tdcerhverv/parrotfish/dist/icons/Icons/Documents.svg';
import Dots from '@tdcerhverv/parrotfish/dist/icons/Icons/Dots.svg';
import Dots_horisontal from '@tdcerhverv/parrotfish/dist/icons/Icons/Dots_horisontal.svg';
import Drag from '@tdcerhverv/parrotfish/dist/icons/Icons/Drag.svg';
import E_sim from '@tdcerhverv/parrotfish/dist/icons/Icons/E_sim.svg';
import Earth_heart_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Earth_heart_light.svg';
import Edit from '@tdcerhverv/parrotfish/dist/icons/Icons/Edit.svg';
import Edit_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Edit_light.svg';
import Error from '@tdcerhverv/parrotfish/dist/icons/Icons/Error.svg';
import Error_filled from '@tdcerhverv/parrotfish/dist/icons/Icons/Error_filled.svg';
import Error_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Error_light.svg';
import Expand from '@tdcerhverv/parrotfish/dist/icons/Icons/Expand.svg';
import Expand_down from '@tdcerhverv/parrotfish/dist/icons/Icons/Expand_down.svg';
import Expand_left from '@tdcerhverv/parrotfish/dist/icons/Icons/Expand_left.svg';
import Expand_right from '@tdcerhverv/parrotfish/dist/icons/Icons/Expand_right.svg';
import Expand_up from '@tdcerhverv/parrotfish/dist/icons/Icons/Expand_up.svg';
import Expand_up_down from '@tdcerhverv/parrotfish/dist/icons/Icons/Expand_up_down.svg';
import External_link from '@tdcerhverv/parrotfish/dist/icons/Icons/External_link.svg';
import Eye_hidden from '@tdcerhverv/parrotfish/dist/icons/Icons/Eye_hidden.svg';
import Eye_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Eye_light.svg';
import Eye_view from '@tdcerhverv/parrotfish/dist/icons/Icons/Eye_view.svg';
import Facebook from '@tdcerhverv/parrotfish/dist/icons/Icons/Facebook.svg';
import File_download from '@tdcerhverv/parrotfish/dist/icons/Icons/File_download.svg';
import File_upload from '@tdcerhverv/parrotfish/dist/icons/Icons/File_upload.svg';
import Filter from '@tdcerhverv/parrotfish/dist/icons/Icons/Filter.svg';
import Folder from '@tdcerhverv/parrotfish/dist/icons/Icons/Folder.svg';
import Folder_media from '@tdcerhverv/parrotfish/dist/icons/Icons/Folder_media.svg';
import Forward_call_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Forward_call_light.svg';
import Frame_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Frame_light.svg';
import Globe_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Globe_light.svg';
import Graph from '@tdcerhverv/parrotfish/dist/icons/Icons/Graph.svg';
import Graph_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Graph_light.svg';
import Grid from '@tdcerhverv/parrotfish/dist/icons/Icons/Grid.svg';
import Groundwork from '@tdcerhverv/parrotfish/dist/icons/Icons/Groundwork.svg';
import Growth_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Growth_light.svg';
import Hands_heart_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Hands_heart_light.svg';
import Handshake_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Handshake_light.svg';
import Headset from '@tdcerhverv/parrotfish/dist/icons/Icons/Headset.svg';
import Headset_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Headset_light.svg';
import Help_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Help_light.svg';
import Hexagon from '@tdcerhverv/parrotfish/dist/icons/Icons/Hexagon.svg';
import Hierarchy_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Hierarchy_light.svg';
import Hierarchy_users_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Hierarchy_users_light.svg';
import Home from '@tdcerhverv/parrotfish/dist/icons/Icons/Home.svg';
import Home_network_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Home_network_light.svg';
import Hourglass from '@tdcerhverv/parrotfish/dist/icons/Icons/Hourglass.svg';
import House_Chimney_light from '@tdcerhverv/parrotfish/dist/icons/Icons/House_Chimney_light.svg';
import Huntgroup from '@tdcerhverv/parrotfish/dist/icons/Icons/Huntgroup.svg';
import Icon_3g from '@tdcerhverv/parrotfish/dist/icons/Icons/Icon_3g.svg';
import Icon_3g_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Icon_3g_light.svg';
import Icon_4g_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Icon_4g_light.svg';
import Icon_5G_full_Black from '@tdcerhverv/parrotfish/dist/icons/Icons/Icon_5G_full_Black.svg';
import Icon_5G_logo from '@tdcerhverv/parrotfish/dist/icons/Icons/Icon_5G_logo.svg';
import Icon_5g from '@tdcerhverv/parrotfish/dist/icons/Icons/Icon_5g.svg';
import Icon_5g_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Icon_5g_light.svg';
import Infinite_loop_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Infinite_loop_light.svg';
import Info from '@tdcerhverv/parrotfish/dist/icons/Icons/Info.svg';
import Info_filled from '@tdcerhverv/parrotfish/dist/icons/Icons/Info_filled.svg';
import Information_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Information_light.svg';
import Integration from '@tdcerhverv/parrotfish/dist/icons/Icons/Integration.svg';
import Intelligence_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Intelligence_light.svg';
import Internet from '@tdcerhverv/parrotfish/dist/icons/Icons/Internet.svg';
import Internet_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Internet_light.svg';
import Internetfilter from '@tdcerhverv/parrotfish/dist/icons/Icons/Internetfilter.svg';
import Invalid_number from '@tdcerhverv/parrotfish/dist/icons/Icons/Invalid_number.svg';
import Invoice from '@tdcerhverv/parrotfish/dist/icons/Icons/Invoice.svg';
import IoT from '@tdcerhverv/parrotfish/dist/icons/Icons/IoT.svg';
import IoT_1 from '@tdcerhverv/parrotfish/dist/icons/Icons/IoT_1.svg';
import IoT_light from '@tdcerhverv/parrotfish/dist/icons/Icons/IoT_light.svg';
import Key_lock_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Key_lock_light.svg';
import Landline_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Landline_light.svg';
import Laptop from '@tdcerhverv/parrotfish/dist/icons/Icons/Laptop.svg';
import Laptop_1_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Laptop_1_light.svg';
import Laptop_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Laptop_light.svg';
import Laptop_wifi from '@tdcerhverv/parrotfish/dist/icons/Icons/Laptop_wifi.svg';
import Layer from '@tdcerhverv/parrotfish/dist/icons/Icons/Layer.svg';
import Leaf_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Leaf_light.svg';
import License_light from '@tdcerhverv/parrotfish/dist/icons/Icons/License_light.svg';
import Liftoff_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Liftoff_light.svg';
import Link from '@tdcerhverv/parrotfish/dist/icons/Icons/Link.svg';
import Link_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Link_light.svg';
import LinkedIn from '@tdcerhverv/parrotfish/dist/icons/Icons/LinkedIn.svg';
import List_bullets_light from '@tdcerhverv/parrotfish/dist/icons/Icons/List_bullets_light.svg';
import List_numbers_light from '@tdcerhverv/parrotfish/dist/icons/Icons/List_numbers_light.svg';
import Location from '@tdcerhverv/parrotfish/dist/icons/Icons/Location.svg';
import Location_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Location_light.svg';
import Lock from '@tdcerhverv/parrotfish/dist/icons/Icons/Lock.svg';
import Lock_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Lock_light.svg';
import Logout from '@tdcerhverv/parrotfish/dist/icons/Icons/Logout.svg';
import Logout_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Logout_light.svg';
import Mail from '@tdcerhverv/parrotfish/dist/icons/Icons/Mail.svg';
import Main_mobile_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Main_mobile_light.svg';
import Main_number from '@tdcerhverv/parrotfish/dist/icons/Icons/Main_number.svg';
import Malware_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Malware_light.svg';
import Meeting_Laptop_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Meeting_Laptop_light.svg';
import Meeting_Smartphone_Hold_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Meeting_Smartphone_Hold_light.svg';
import Menu_hamburger from '@tdcerhverv/parrotfish/dist/icons/Icons/Menu_hamburger.svg';
import Menu_vertical from '@tdcerhverv/parrotfish/dist/icons/Icons/Menu_vertical.svg';
import Microsoft_users_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Microsoft_users_light.svg';
import Minus from '@tdcerhverv/parrotfish/dist/icons/Icons/Minus.svg';
import Minus_1 from '@tdcerhverv/parrotfish/dist/icons/Icons/Minus_1.svg';
import Mobile from '@tdcerhverv/parrotfish/dist/icons/Icons/Mobile.svg';
import Mobile_Phone_2_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Mobile_Phone_2_light.svg';
import Mobile_broadband from '@tdcerhverv/parrotfish/dist/icons/Icons/Mobile_broadband.svg';
import Mobile_broadband_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Mobile_broadband_light.svg';
import Mobile_cover from '@tdcerhverv/parrotfish/dist/icons/Icons/Mobile_cover.svg';
import Mobile_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Mobile_light.svg';
import Mobile_lock_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Mobile_lock_light.svg';
import Monitor_Question_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Monitor_Question_light.svg';
import Music from '@tdcerhverv/parrotfish/dist/icons/Icons/Music.svg';
import Music_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Music_light.svg';
import Music_node_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Music_node_light.svg';
import Nature_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Nature_light.svg';
import Nemkonto_symbol from '@tdcerhverv/parrotfish/dist/icons/Icons/Nemkonto_symbol.svg';
import Network_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Network_light.svg';
import Network_units_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Network_units_light.svg';
import News from '@tdcerhverv/parrotfish/dist/icons/Icons/News.svg';
import News_light from '@tdcerhverv/parrotfish/dist/icons/Icons/News_light.svg';
import Node_circle from '@tdcerhverv/parrotfish/dist/icons/Icons/Node_circle.svg';
import Notification from '@tdcerhverv/parrotfish/dist/icons/Icons/Notification.svg';
import Notification_bell_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Notification_bell_light.svg';
import Office365_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Office365_light.svg';
import One from '@tdcerhverv/parrotfish/dist/icons/Icons/One.svg';
import OnePlus from '@tdcerhverv/parrotfish/dist/icons/Icons/OnePlus.svg';
import One_light from '@tdcerhverv/parrotfish/dist/icons/Icons/One_light.svg';
import One_plus_light from '@tdcerhverv/parrotfish/dist/icons/Icons/One_plus_light.svg';
import Online_meeting_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Online_meeting_light.svg';
import Password from '@tdcerhverv/parrotfish/dist/icons/Icons/Password.svg';
import Password_check_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Password_check_light.svg';
import Password_lock_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Password_lock_light.svg';
import Pause from '@tdcerhverv/parrotfish/dist/icons/Icons/Pause.svg';
import Phishing_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Phishing_light.svg';
import Phone from '@tdcerhverv/parrotfish/dist/icons/Icons/Phone.svg';
import Phone_70 from '@tdcerhverv/parrotfish/dist/icons/Icons/Phone_70.svg';
import Phone_80 from '@tdcerhverv/parrotfish/dist/icons/Icons/Phone_80.svg';
import Phone_SIP from '@tdcerhverv/parrotfish/dist/icons/Icons/Phone_SIP.svg';
import Phone_connect from '@tdcerhverv/parrotfish/dist/icons/Icons/Phone_connect.svg';
import Phone_filled from '@tdcerhverv/parrotfish/dist/icons/Icons/Phone_filled.svg';
import Phone_landline from '@tdcerhverv/parrotfish/dist/icons/Icons/Phone_landline.svg';
import Phone_message from '@tdcerhverv/parrotfish/dist/icons/Icons/Phone_message.svg';
import Phone_message_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Phone_message_light.svg';
import Phone_outgoing_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Phone_outgoing_light.svg';
import Phone_setup from '@tdcerhverv/parrotfish/dist/icons/Icons/Phone_setup.svg';
import Piggy_money_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Piggy_money_light.svg';
import Pin_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Pin_light.svg';
import Pin from '@tdcerhverv/parrotfish/dist/icons/Icons/Pin.svg';
import Pin_filled from '@tdcerhverv/parrotfish/dist/icons/Icons/Pin_filled.svg';
import Play from '@tdcerhverv/parrotfish/dist/icons/Icons/Play.svg';
import Plus from '@tdcerhverv/parrotfish/dist/icons/Icons/Plus.svg';
import Plus_1 from '@tdcerhverv/parrotfish/dist/icons/Icons/Plus_1.svg';
import Plus_add_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Plus_add_light.svg';
import Power_Button from '@tdcerhverv/parrotfish/dist/icons/Icons/Power_Button.svg';
import Power_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Power_light.svg';
import Print from '@tdcerhverv/parrotfish/dist/icons/Icons/Print.svg';
import Question from '@tdcerhverv/parrotfish/dist/icons/Icons/Question.svg';
import Question_help_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Question_help_light.svg';
import Quote_close from '@tdcerhverv/parrotfish/dist/icons/Icons/Quote_close.svg';
import Quote_open from '@tdcerhverv/parrotfish/dist/icons/Icons/Quote_open.svg';
import Reception_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Reception_light.svg';
import Record from '@tdcerhverv/parrotfish/dist/icons/Icons/Record.svg';
import Record_microphone from '@tdcerhverv/parrotfish/dist/icons/Icons/Record_microphone.svg';
import Redo from '@tdcerhverv/parrotfish/dist/icons/Icons/Redo.svg';
import Refresh from '@tdcerhverv/parrotfish/dist/icons/Icons/Refresh.svg';
import Refresh_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Refresh_light.svg';
import Remove_filled from '@tdcerhverv/parrotfish/dist/icons/Icons/Remove_filled.svg';
import Replay from '@tdcerhverv/parrotfish/dist/icons/Icons/Replay.svg';
import Report from '@tdcerhverv/parrotfish/dist/icons/Icons/Report.svg';
import Roaming from '@tdcerhverv/parrotfish/dist/icons/Icons/Roaming.svg';
import Robot_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Robot_light.svg';
import Rocket_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Rocket_light.svg';
import Router from '@tdcerhverv/parrotfish/dist/icons/Icons/Router.svg';
import Router_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Router_light.svg';
import SMS from '@tdcerhverv/parrotfish/dist/icons/Icons/SMS.svg';
import Save from '@tdcerhverv/parrotfish/dist/icons/Icons/Save.svg';
import Scalable_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Scalable_light.svg';
import Scale from '@tdcerhverv/parrotfish/dist/icons/Icons/Scale.svg';
import Scale_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Scale_light.svg';
import Scale_weight_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Scale_weight_light.svg';
import Search from '@tdcerhverv/parrotfish/dist/icons/Icons/Search.svg';
import Search_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Search_light.svg';
import Search_mobile from '@tdcerhverv/parrotfish/dist/icons/Icons/Search_mobile.svg';
import Security from '@tdcerhverv/parrotfish/dist/icons/Icons/Security.svg';
import Security_Lock_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Security_Lock_light.svg';
import Security_VPN_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Security_VPN_light.svg';
import Security_Wifi_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Security_Wifi_light.svg';
import Security_check from '@tdcerhverv/parrotfish/dist/icons/Icons/Security_check.svg';
import Security_cloud_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Security_cloud_light.svg';
import Selfservice from '@tdcerhverv/parrotfish/dist/icons/Icons/Selfservice.svg';
import Selfservice_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Selfservice_light.svg';
import Semiselect from '@tdcerhverv/parrotfish/dist/icons/Icons/Semiselect.svg';
import Send_email from '@tdcerhverv/parrotfish/dist/icons/Icons/Send_email.svg';
import Server_Sync_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Server_Sync_light.svg';
import Server_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Server_light.svg';
import Settings from '@tdcerhverv/parrotfish/dist/icons/Icons/Settings.svg';
import Settings_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Settings_light.svg';
import Shield_check_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Shield_check_light.svg';
import Shopping_cart from '@tdcerhverv/parrotfish/dist/icons/Icons/Shopping_cart.svg';
import Signal_1 from '@tdcerhverv/parrotfish/dist/icons/Icons/Signal_1.svg';
import Signal_2 from '@tdcerhverv/parrotfish/dist/icons/Icons/Signal_2.svg';
import Signal_3 from '@tdcerhverv/parrotfish/dist/icons/Icons/Signal_3.svg';
import Signal_4 from '@tdcerhverv/parrotfish/dist/icons/Icons/Signal_4.svg';
import Signal_5 from '@tdcerhverv/parrotfish/dist/icons/Icons/Signal_5.svg';
import Signal_check_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Signal_check_light.svg';
import Sim_card from '@tdcerhverv/parrotfish/dist/icons/Icons/Sim_card.svg';
import Sim_card_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Sim_card_light.svg';
import Sim_devices_network_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Sim_devices_network_light.svg';
import Skype from '@tdcerhverv/parrotfish/dist/icons/Icons/Skype.svg';
import Skype_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Skype_light.svg';
import Smiley_happy from '@tdcerhverv/parrotfish/dist/icons/Icons/Smiley_happy.svg';
import Smiley_happy_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Smiley_happy_light.svg';
import Smiley_indifferent from '@tdcerhverv/parrotfish/dist/icons/Icons/Smiley_indifferent.svg';
import Smiley_neutral_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Smiley_neutral_light.svg';
import Smiley_pleased_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Smiley_pleased_light.svg';
import Smiley_sad from '@tdcerhverv/parrotfish/dist/icons/Icons/Smiley_sad.svg';
import Smiley_unhappy_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Smiley_unhappy_light.svg';
import Smiley_unpleased_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Smiley_unpleased_light.svg';
import Softphone from '@tdcerhverv/parrotfish/dist/icons/Icons/Softphone.svg';
import Sound from '@tdcerhverv/parrotfish/dist/icons/Icons/Sound.svg';
import Sound_off from '@tdcerhverv/parrotfish/dist/icons/Icons/Sound_off.svg';
import Spam_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Spam_light.svg';
import Speed from '@tdcerhverv/parrotfish/dist/icons/Icons/Speed.svg';
import Speed_measure from '@tdcerhverv/parrotfish/dist/icons/Icons/Speed_measure.svg';
import Star from '@tdcerhverv/parrotfish/dist/icons/Icons/Star.svg';
import Stars_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Stars_light.svg';
import Stop_cancel_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Stop_cancel_light.svg';
import Stop_media from '@tdcerhverv/parrotfish/dist/icons/Icons/Stop_media.svg';
import Stop_sign_ from '@tdcerhverv/parrotfish/dist/icons/Icons/Stop_sign_.svg';
import Subscription from '@tdcerhverv/parrotfish/dist/icons/Icons/Subscription.svg';
import Subscription_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Subscription_light.svg';
import Subscriptions_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Subscriptions_light.svg';
import Success from '@tdcerhverv/parrotfish/dist/icons/Icons/Success.svg';
import Success_filled from '@tdcerhverv/parrotfish/dist/icons/Icons/Success_filled.svg';
import Support from '@tdcerhverv/parrotfish/dist/icons/Icons/Support.svg';
import Support_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Support_light.svg';
import Table_list from '@tdcerhverv/parrotfish/dist/icons/Icons/Table_list.svg';
import Tablet from '@tdcerhverv/parrotfish/dist/icons/Icons/Tablet.svg';
import Tablet_1_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Tablet_1_light.svg';
import Team_Meeting_Message_Question_1_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Team_Meeting_Message_Question_1_light.svg';
import Teams from '@tdcerhverv/parrotfish/dist/icons/Icons/Teams.svg';
import Teams_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Teams_light.svg';
import Text_pad from '@tdcerhverv/parrotfish/dist/icons/Icons/Text_pad.svg';
import Thumbs_down from '@tdcerhverv/parrotfish/dist/icons/Icons/Thumbs_down.svg';
import Thumbs_down_2_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Thumbs_down_2_light.svg';
import Thumbs_down_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Thumbs_down_light.svg';
import Thumbs_up from '@tdcerhverv/parrotfish/dist/icons/Icons/Thumbs_up.svg';
import Thumbs_up_2_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Thumbs_up_2_light.svg';
import Thumbs_up_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Thumbs_up_light.svg';
import Time from '@tdcerhverv/parrotfish/dist/icons/Icons/Time.svg';
import Time_filled from '@tdcerhverv/parrotfish/dist/icons/Icons/Time_filled.svg';
import Tools_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Tools_light.svg';
import Touch_id_user_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Touch_id_user_light.svg';
import Touch_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Touch_light.svg';
import Trash from '@tdcerhverv/parrotfish/dist/icons/Icons/Trash.svg';
import Trash_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Trash_light.svg';
import USB_Cable from '@tdcerhverv/parrotfish/dist/icons/Icons/USB_Cable.svg';
import Undo from '@tdcerhverv/parrotfish/dist/icons/Icons/Undo.svg';
import Unkown_number from '@tdcerhverv/parrotfish/dist/icons/Icons/Unkown_number.svg';
import Unlock from '@tdcerhverv/parrotfish/dist/icons/Icons/Unlock.svg';
import Unlock_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Unlock_light.svg';
import Update from '@tdcerhverv/parrotfish/dist/icons/Icons/Update.svg';
import Usage_tool from '@tdcerhverv/parrotfish/dist/icons/Icons/Usage_tool.svg';
import User from '@tdcerhverv/parrotfish/dist/icons/Icons/User.svg';
import User_2_light from '@tdcerhverv/parrotfish/dist/icons/Icons/User_2_light.svg';
import User_3_light from '@tdcerhverv/parrotfish/dist/icons/Icons/User_3_light.svg';
import User_4_light from '@tdcerhverv/parrotfish/dist/icons/Icons/User_4_light.svg';
import User_add from '@tdcerhverv/parrotfish/dist/icons/Icons/User_add.svg';
import User_application_light from '@tdcerhverv/parrotfish/dist/icons/Icons/User_application_light.svg';
import User_contact_light from '@tdcerhverv/parrotfish/dist/icons/Icons/User_contact_light.svg';
import User_envelope_light from '@tdcerhverv/parrotfish/dist/icons/Icons/User_envelope_light.svg';
import User_home_light from '@tdcerhverv/parrotfish/dist/icons/Icons/User_home_light.svg';
import User_light from '@tdcerhverv/parrotfish/dist/icons/Icons/User_light.svg';
import User_message_light from '@tdcerhverv/parrotfish/dist/icons/Icons/User_message_light.svg';
import User_phone from '@tdcerhverv/parrotfish/dist/icons/Icons/User_phone.svg';
import User_remove from '@tdcerhverv/parrotfish/dist/icons/Icons/User_remove.svg';
import User_unkown from '@tdcerhverv/parrotfish/dist/icons/Icons/User_unkown.svg';
import User_wifi_light from '@tdcerhverv/parrotfish/dist/icons/Icons/User_wifi_light.svg';
import Users from '@tdcerhverv/parrotfish/dist/icons/Icons/Users.svg';
import Users_2_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Users_2_light.svg';
import Users_access from '@tdcerhverv/parrotfish/dist/icons/Icons/Users_access.svg';
import Users_global_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Users_global_light.svg';
import Users_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Users_light.svg';
import Users_ticket_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Users_ticket_light.svg';
import Voicemail from '@tdcerhverv/parrotfish/dist/icons/Icons/Voicemail.svg';
import Voicemail_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Voicemail_light.svg';
import Wallet from '@tdcerhverv/parrotfish/dist/icons/Icons/Wallet.svg';
import Warning from '@tdcerhverv/parrotfish/dist/icons/Icons/Warning.svg';
import Warning_filled from '@tdcerhverv/parrotfish/dist/icons/Icons/Warning_filled.svg';
import Warning_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Warning_light.svg';
import Watch from '@tdcerhverv/parrotfish/dist/icons/Icons/Watch.svg';
import Watch_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Watch_light.svg';
import Webex_filled from '@tdcerhverv/parrotfish/dist/icons/Icons/Webex_filled.svg';
import Webex_logo from '@tdcerhverv/parrotfish/dist/icons/Icons/Webex_logo.svg';
import Webex_outlined_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Webex_outlined_light.svg';
import Wifi from '@tdcerhverv/parrotfish/dist/icons/Icons/Wifi.svg';
import Wifi_Delete_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Wifi_Delete_light.svg';
import Wifi_check_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Wifi_check_light.svg';
import Wifi_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Wifi_light.svg';
import YouSee_Logo from '@tdcerhverv/parrotfish/dist/icons/Icons/YouSee_Logo.svg';
import Yousee_TV from '@tdcerhverv/parrotfish/dist/icons/Icons/Yousee_TV.svg';
import Zoom_in from '@tdcerhverv/parrotfish/dist/icons/Icons/Zoom_in.svg';
import Zoom_out from '@tdcerhverv/parrotfish/dist/icons/Icons/Zoom_out.svg';
import nuuday_simple_logo from '@tdcerhverv/parrotfish/dist/icons/Icons/nuuday_simple_logo.svg';
import tdc_logo_outline from '@tdcerhverv/parrotfish/dist/icons/Icons/tdc_logo_outline.svg';
import tdc_logo_primary from '@tdcerhverv/parrotfish/dist/icons/Icons/tdc_logo_primary.svg';
import tdc_logo_primary_light from '@tdcerhverv/parrotfish/dist/icons/Icons/tdc_logo_primary_light.svg';
import tdc_logo_primary_negative from '@tdcerhverv/parrotfish/dist/icons/Icons/tdc_logo_primary_negative.svg';
import tdc_logo_primary_negative_light from '@tdcerhverv/parrotfish/dist/icons/Icons/tdc_logo_primary_negative_light.svg';
import tdc_net_logo from '@tdcerhverv/parrotfish/dist/icons/Icons/tdc_net_logo.svg';
import tdc_simple_logo from '@tdcerhverv/parrotfish/dist/icons/Icons/tdc_simple_logo.svg';
export const iconsMap = {
Account_number: Account_number,
Align_left: Align_left,
Align_right: Align_right,
Announce_light: Announce_light,
Antenna_light: Antenna_light,
Antenna_signal: Antenna_signal,
Application_light: Application_light,
Arrow_circle_down: Arrow_circle_down,
Arrow_circle_up: Arrow_circle_up,
Arrow_directions: Arrow_directions,
Arrow_down: Arrow_down,
Arrow_down_light: Arrow_down_light,
Arrow_left: Arrow_left,
Arrow_left_light: Arrow_left_light,
Arrow_right: Arrow_right,
Arrow_right_light: Arrow_right_light,
Arrow_up: Arrow_up,
Arrow_up_light: Arrow_up_light,
Arrows_up_down: Arrows_up_down,
Assistapp_filled: Assistapp_filled,
Assistapp_stroke_light: Assistapp_stroke_light,
At_Sign: At_Sign,
Attach: Attach,
Attach_light: Attach_light,
Autoattendant: Autoattendant,
Backspace: Backspace,
Bank: Bank,
Battery_full_light: Battery_full_light,
Battery_low_light: Battery_low_light,
Battery_power: Battery_power,
Book: Book,
Brain_Head_2_light: Brain_Head_2_light,
Briefcase: Briefcase,
Broken_link: Broken_link,
Browser_light: Browser_light,
Bus_station_light: Bus_station_light,
Business: Business,
Cable_copper: Cable_copper,
Cable_copper_light: Cable_copper_light,
Cable_fiber_light: Cable_fiber_light,
Cable_lan_ethernet: Cable_lan_ethernet,
Cable_lan_ethernet_light: Cable_lan_ethernet_light,
Calendar: Calendar,
Calendar_light: Calendar_light,
Call_made: Call_made,
Call_missed: Call_missed,
Call_recieved: Call_recieved,
Callflow: Callflow,
Callflow_incomplete: Callflow_incomplete,
Callflow_light: Callflow_light,
Callmanager: Callmanager,
Cart_light: Cart_light,
Certificate_light: Certificate_light,
Change: Change,
Chat: Chat,
Chat_light: Chat_light,
Check: Check,
Check_1: Check_1,
Check_Badge: Check_Badge,
Checkmark: Checkmark,
Checkmark_round_light: Checkmark_round_light,
Checkmark_stroke_light: Checkmark_stroke_light,
Clear: Clear,
Close: Close,
Close_light: Close_light,
Cloud: Cloud,
Cloud_key: Cloud_key,
Cloud_key_light: Cloud_key_light,
Cloud_light: Cloud_light,
Cloud_wifi_light: Cloud_wifi_light,
Collapse_left: Collapse_left,
Collapse_right: Collapse_right,
Columns: Columns,
Common_file_text_warning: Common_file_text_warning,
Company_heart_light: Company_heart_light,
Company_settings: Company_settings,
Comprimised_light: Comprimised_light,
Computer_to_cloud_light: Computer_to_cloud_light,
Consumption: Consumption,
Consumtion_light: Consumtion_light,
Contact_person: Contact_person,
Contacts: Contacts,
Covrage: Covrage,
Crypto_mining_light: Crypto_mining_light,
Cursor_light: Cursor_light,
Cyper_crime: Cyper_crime,
DKK_transparent_light: DKK_transparent_light,
DSL: DSL,
Danmarks_bedste_5g_mobilnet_lys_blaa: Danmarks_bedste_5g_mobilnet_lys_blaa,
Danmarks_bedste_5g_mobilnet_lys_blaa_inverted: Danmarks_bedste_5g_mobilnet_lys_blaa_inverted,
Danmarks_bedste_5g_mobilnet_moerk_blaa: Danmarks_bedste_5g_mobilnet_moerk_blaa,
Danmarks_bedste_5g_mobilnet_moerk_blaa_inverted: Danmarks_bedste_5g_mobilnet_moerk_blaa_inverted,
Danmarks_bedste_mobilnet_8_aar_lys_blaa: Danmarks_bedste_mobilnet_8_aar_lys_blaa,
Danmarks_bedste_mobilnet_8_aar_lys_blaa_inverted: Danmarks_bedste_mobilnet_8_aar_lys_blaa_inverted,
Danmarks_bedste_mobilnet_8_aar_moerk_blaa: Danmarks_bedste_mobilnet_8_aar_moerk_blaa,
Danmarks_bedste_mobilnet_8_aar_moerk_blaa_inverted: Danmarks_bedste_mobilnet_8_aar_moerk_blaa_inverted,
Danmarks_bedste_mobilnet_bedst_i_test_lys_blaa: Danmarks_bedste_mobilnet_bedst_i_test_lys_blaa,
Danmarks_bedste_mobilnet_bedst_i_test_lys_blaa_inverted: Danmarks_bedste_mobilnet_bedst_i_test_lys_blaa_inverted,
Danmarks_bedste_mobilnet_bedst_i_test_moerk_blaa: Danmarks_bedste_mobilnet_bedst_i_test_moerk_blaa,
Danmarks_bedste_mobilnet_bedst_i_test_moerk_blaa_inverted: Danmarks_bedste_mobilnet_bedst_i_test_moerk_blaa_inverted,
Danmarks_bedste_mobilnet_lys_blaa: Danmarks_bedste_mobilnet_lys_blaa,
Danmarks_bedste_mobilnet_lys_blaa_inverted: Danmarks_bedste_mobilnet_lys_blaa_inverted,
Danmarks_bedste_mobilnet_moerk_blaa: Danmarks_bedste_mobilnet_moerk_blaa,
Danmarks_bedste_mobilnet_moerk_blaa_inverted: Danmarks_bedste_mobilnet_moerk_blaa_inverted,
Danmarks_bedste_mobilnet_symbol_og_txt_lys_blaa: Danmarks_bedste_mobilnet_symbol_og_txt_lys_blaa,
Danmarks_bedste_mobilnet_symbol_og_txt_lys_blaa_inverted: Danmarks_bedste_mobilnet_symbol_og_txt_lys_blaa_inverted,
Danmarks_bedste_mobilnet_symbol_og_txt_moerk_blaa: Danmarks_bedste_mobilnet_symbol_og_txt_moerk_blaa,
Danmarks_bedste_mobilnet_symbol_og_txt_moerk_blaa_inverted: Danmarks_bedste_mobilnet_symbol_og_txt_moerk_blaa_inverted,
Dashboard: Dashboard,
Database_light: Database_light,
Delivery_truck_light: Delivery_truck_light,
Denmark_map_light: Denmark_map_light,
Desk_light: Desk_light,
Dial_number_light: Dial_number_light,
Dialog_light: Dialog_light,
Diamond: Diamond,
Document: Document,
Document_time: Document_time,
Documents: Documents,
Dots: Dots,
Dots_horisontal: Dots_horisontal,
Drag: Drag,
E_sim: E_sim,
Earth_heart_light: Earth_heart_light,
Edit: Edit,
Edit_light: Edit_light,
Error: Error,
Error_filled: Error_filled,
Error_light: Error_light,
Expand: Expand,
Expand_down: Expand_down,
Expand_left: Expand_left,
Expand_right: Expand_right,
Expand_up: Expand_up,
Expand_up_down: Expand_up_down,
External_link: External_link,
Eye_hidden: Eye_hidden,
Eye_light: Eye_light,
Eye_view: Eye_view,
Facebook: Facebook,
File_download: File_download,
File_upload: File_upload,
Filter: Filter,
Folder: Folder,
Folder_media: Folder_media,
Forward_call_light: Forward_call_light,
Frame_light: Frame_light,
Globe_light: Globe_light,
Graph: Graph,
Graph_light: Graph_light,
Grid: Grid,
Groundwork: Groundwork,
Growth_light: Growth_light,
Hands_heart_light: Hands_heart_light,
Handshake_light: Handshake_light,
Headset: Headset,
Headset_light: Headset_light,
Help_light: Help_light,
Hexagon: Hexagon,
Hierarchy_light: Hierarchy_light,
Hierarchy_users_light: Hierarchy_users_light,
Home: Home,
Home_network_light: Home_network_light,
Hourglass: Hourglass,
House_Chimney_light: House_Chimney_light,
Huntgroup: Huntgroup,
Icon_3g: Icon_3g,
Icon_3g_light: Icon_3g_light,
Icon_4g_light: Icon_4g_light,
Icon_5G_full_Black: Icon_5G_full_Black,
Icon_5G_logo: Icon_5G_logo,
Icon_5g: Icon_5g,
Icon_5g_light: Icon_5g_light,
Infinite_loop_light: Infinite_loop_light,
Info: Info,
Info_filled: Info_filled,
Information_light: Information_light,
Integration: Integration,
Intelligence_light: Intelligence_light,
Internet: Internet,
Internet_light: Internet_light,
Internetfilter: Internetfilter,
Invalid_number: Invalid_number,
Invoice: Invoice,
IoT: IoT,
IoT_1: IoT_1,
IoT_light: IoT_light,
Key_lock_light: Key_lock_light,
Landline_light: Landline_light,
Laptop: Laptop,
Laptop_1_light: Laptop_1_light,
Laptop_light: Laptop_light,
Laptop_wifi: Laptop_wifi,
Layer: Layer,
Leaf_light: Leaf_light,
License_light: License_light,
Liftoff_light: Liftoff_light,
Link: Link,
Link_light: Link_light,
LinkedIn: LinkedIn,
List_bullets_light: List_bullets_light,
List_numbers_light: List_numbers_light,
Location: Location,
Location_light: Location_light,
Lock: Lock,
Lock_light: Lock_light,
Logout: Logout,
Logout_light: Logout_light,
Mail: Mail,
Main_mobile_light: Main_mobile_light,
Main_number: Main_number,
Malware_light: Malware_light,
Meeting_Laptop_light: Meeting_Laptop_light,
Meeting_Smartphone_Hold_light: Meeting_Smartphone_Hold_light,
Menu_hamburger: Menu_hamburger,
Menu_vertical: Menu_vertical,
Microsoft_users_light: Microsoft_users_light,
Minus: Minus,
Minus_1: Minus_1,
Mobile: Mobile,
Mobile_Phone_2_light: Mobile_Phone_2_light,
Mobile_broadband: Mobile_broadband,
Mobile_broadband_light: Mobile_broadband_light,
Mobile_cover: Mobile_cover,
Mobile_light: Mobile_light,
Mobile_lock_light: Mobile_lock_light,
Monitor_Question_light: Monitor_Question_light,
Music: Music,
Music_light: Music_light,
Music_node_light: Music_node_light,
Nature_light: Nature_light,
Nemkonto_symbol: Nemkonto_symbol,
Network_light: Network_light,
Network_units_light: Network_units_light,
News: News,
News_light: News_light,
Node_circle: Node_circle,
Notification: Notification,
Notification_bell_light: Notification_bell_light,
Office365_light: Office365_light,
One: One,
OnePlus: OnePlus,
One_light: One_light,
One_plus_light: One_plus_light,
Online_meeting_light: Online_meeting_light,
Password: Password,
Password_check_light: Password_check_light,
Password_lock_light: Password_lock_light,
Pause: Pause,
Phishing_light: Phishing_light,
Phone: Phone,
Phone_70: Phone_70,
Phone_80: Phone_80,
Phone_SIP: Phone_SIP,
Phone_connect: Phone_connect,
Phone_filled: Phone_filled,
Phone_landline: Phone_landline,
Phone_message: Phone_message,
Phone_message_light: Phone_message_light,
Phone_outgoing_light: Phone_outgoing_light,
Phone_setup: Phone_setup,
Piggy_money_light: Piggy_money_light,
Pin_light: Pin_light,
Pin: Pin,
Pin_filled: Pin_filled,
Play: Play,
Plus: Plus,
Plus_1: Plus_1,
Plus_add_light: Plus_add_light,
Power_Button: Power_Button,
Power_light: Power_light,
Print: Print,
Question: Question,
Question_help_light: Question_help_light,
Quote_close: Quote_close,
Quote_open: Quote_open,
Reception_light: Reception_light,
Record: Record,
Record_microphone: Record_microphone,
Redo: Redo,
Refresh: Refresh,
Refresh_light: Refresh_light,
Remove_filled: Remove_filled,
Replay: Replay,
Report: Report,
Roaming: Roaming,
Robot_light: Robot_light,
Rocket_light: Rocket_light,
Router: Router,
Router_light: Router_light,
SMS: SMS,
Save: Save,
Scalable_light: Scalable_light,
Scale: Scale,
Scale_light: Scale_light,
Scale_weight_light: Scale_weight_light,
Search: Search,
Search_light: Search_light,
Search_mobile: Search_mobile,
Security: Security,
Security_Lock_light: Security_Lock_light,
Security_VPN_light: Security_VPN_light,
Security_Wifi_light: Security_Wifi_light,
Security_check: Security_check,
Security_cloud_light: Security_cloud_light,
Selfservice: Selfservice,
Selfservice_light: Selfservice_light,
Semiselect: Semiselect,
Send_email: Send_email,
Server_Sync_light: Server_Sync_light,
Server_light: Server_light,
Settings: Settings,
Settings_light: Settings_light,
Shield_check_light: Shield_check_light,
Shopping_cart: Shopping_cart,
Signal_1: Signal_1,
Signal_2: Signal_2,
Signal_3: Signal_3,
Signal_4: Signal_4,
Signal_5: Signal_5,
Signal_check_light: Signal_check_light,
Sim_card: Sim_card,
Sim_card_light: Sim_card_light,
Sim_devices_network_light: Sim_devices_network_light,
Skype: Skype,
Skype_light: Skype_light,
Smiley_happy: Smiley_happy,
Smiley_happy_light: Smiley_happy_light,
Smiley_indifferent: Smiley_indifferent,
Smiley_neutral_light: Smiley_neutral_light,
Smiley_pleased_light: Smiley_pleased_light,
Smiley_sad: Smiley_sad,
Smiley_unhappy_light: Smiley_unhappy_light,
Smiley_unpleased_light: Smiley_unpleased_light,
Softphone: Softphone,
Sound: Sound,
Sound_off: Sound_off,
Spam_light: Spam_light,
Speed: Speed,
Speed_measure: Speed_measure,
Star: Star,
Stars_light: Stars_light,
Stop_cancel_light: Stop_cancel_light,
Stop_media: Stop_media,
Stop_sign_: Stop_sign_,
Subscription: Subscription,
Subscription_light: Subscription_light,
Subscriptions_light: Subscriptions_light,
Success: Success,
Success_filled: Success_filled,
Support: Support,
Support_light: Support_light,
Table_list: Table_list,
Tablet: Tablet,
Tablet_1_light: Tablet_1_light,
Team_Meeting_Message_Question_1_light: Team_Meeting_Message_Question_1_light,
Teams: Teams,
Teams_light: Teams_light,
Text_pad: Text_pad,
Thumbs_down: Thumbs_down,
Thumbs_down_2_light: Thumbs_down_2_light,
Thumbs_down_light: Thumbs_down_light,
Thumbs_up: Thumbs_up,
Thumbs_up_2_light: Thumbs_up_2_light,
Thumbs_up_light: Thumbs_up_light,
Time: Time,
Time_filled: Time_filled,
Tools_light: Tools_light,
Touch_id_user_light: Touch_id_user_light,
Touch_light: Touch_light,
Trash: Trash,
Trash_light: Trash_light,
USB_Cable: USB_Cable,
Undo: Undo,
Unkown_number: Unkown_number,
Unlock: Unlock,
Unlock_light: Unlock_light,
Update: Update,
Usage_tool: Usage_tool,
User: User,
User_2_light: User_2_light,
User_3_light: User_3_light,
User_4_light: User_4_light,
User_add: User_add,
User_application_light: User_application_light,
User_contact_light: User_contact_light,
User_envelope_light: User_envelope_light,
User_home_light: User_home_light,
User_light: User_light,
User_message_light: User_message_light,
User_phone: User_phone,
User_remove: User_remove,
User_unkown: User_unkown,
User_wifi_light: User_wifi_light,
Users: Users,
Users_2_light: Users_2_light,
Users_access: Users_access,
Users_global_light: Users_global_light,
Users_light: Users_light,
Users_ticket_light: Users_ticket_light,
Voicemail: Voicemail,
Voicemail_light: Voicemail_light,
Wallet: Wallet,
Warning: Warning,
Warning_filled: Warning_filled,
Warning_light: Warning_light,
Watch: Watch,
Watch_light: Watch_light,
Webex_filled: Webex_filled,
Webex_logo: Webex_logo,
Webex_outlined_light: Webex_outlined_light,
Wifi: Wifi,
Wifi_Delete_light: Wifi_Delete_light,
Wifi_check_light: Wifi_check_light,
Wifi_light: Wifi_light,
YouSee_Logo: YouSee_Logo,
Yousee_TV: Yousee_TV,
Zoom_in: Zoom_in,
Zoom_out: Zoom_out,
nuuday_simple_logo: nuuday_simple_logo,
tdc_logo_outline: tdc_logo_outline,
tdc_logo_primary: tdc_logo_primary,
tdc_logo_primary_light: tdc_logo_primary_light,
tdc_logo_primary_negative: tdc_logo_primary_negative,
tdc_logo_primary_negative_light: tdc_logo_primary_negative_light,
tdc_net_logo: tdc_net_logo,
tdc_simple_logo: tdc_simple_logo};